module.exports = __webpack_public_path__ + "static/media/the78boler-IG-1.8c6636e9.PNG";